import { CuroApplicationVariables } from 'enums/curo/Variables';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';

import useGetGeocode from './useGetGeocode';

const useGetBranchGeocode = () => {
  const application = useAppSelector(getApplicationSelector)!;

  const branchPhone = application?.variables[CuroApplicationVariables.SnowflakeBorrowerBranchPhone] as string;
  const branchStreet = application?.variables[CuroApplicationVariables.BranchStreet] as string;
  const branchCityStateZip = application?.variables[CuroApplicationVariables.BranchCityStateZip] as string;
  const offerExpirationDate = application?.variables[CuroApplicationVariables.OfferExpirationDate] as string;

  const { latLng, getDirection } = useGetGeocode({ 
    branchCityStateZip, 
    branchPhone, 
    branchStreet,
  });

  return {
    getDirection,
    branchPhone,
    branchStreet,
    branchCityStateZip,
    latLng,
    offerExpirationDate,
  }
}

export default useGetBranchGeocode;
